import { buildErrorsFromMsgs, buildErrorsFromResponse } from '../utils/errorHandling';

export const CLEAR_LOGIN_DATA = "CLEAR_LOGIN_DATA";
export const LOGIN_DATA = 'LOGIN_DATA';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_FINISHED = 'LOGIN_FINISHED';
export const LOGIN_CANCELED = "LOGIN_CANCELED";
export const LOYALTY_VIEW_READY = 'LOYALTY_VIEW_READY';
export const DISABLE_LOYALTY_MODAL = 'DISABLE_LOYALTY_MODAL';
export const RECEIVE_LOYALTY_SUBSCRIPTION = 'RECEIVE_LOYALTY_SUBSCRIPTION';
export const RECEIVE_USER_ADDRESSES = 'RECEIVE_USER_ADDRESSES';
export const RECEIVE_USER_PREFERENCES = 'RECEIVE_USER_PREFERENCES';
export const REQUEST_LOYALTY_SUBSCRIPTION = 'REQUEST_LOYALTY_SUBSCRIPTION';
export const REQUEST_USER_ADDRESSES = 'REQUEST_USER_ADDRESSES';
export const REQUEST_USER_PREFERENCES = 'REQUEST_USER_PREFERENCES';
export const SEND_PASSWORD_DATA = 'SEND_PASSWORD_DATA';
export const SEND_PASSWORD_RESET_SUCCESS = 'SEND_PASSWORD_RESET_SUCCESS';
export const SEND_PASSWORD_RESET_FAILURE = 'SEND_PASSWORD_RESET_FAILURE';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export const SIGNUP_DATA = 'SIGNUP_DATA';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_HANDLED = 'USER_LOGIN_HANDLED';
export const SEND_EMAIL_SIGNUP_DATA = 'SEND_EMAIL_SIGNUP_DATA';
export const SUBMIT_EMAIL_SIGNUP_ADDRESS = 'SUBMIT_EMAIL_SIGNUP_ADDRESS';
export const CLEAR_EMAIL_SIGNUP_DATA = 'CLEAR_EMAIL_SIGNUP_DATA';
export const SAVE_EMAIL_SIGNUP_DATA = 'SAVE_EMAIL_SIGNUP_DATA';
export const EMAIL_SIGNUP_FAILURE = 'EMAIL_SIGNUP_FAILURE';
export const STICKY_SIGNUP_SUCCESS = 'STICKY_SIGNUP_SUCCESS';
export const UPDATE_LOYALTY_USERNAME = 'UPDATE_LOYALTY_USERNAME';
export const SET_LOYALTY_STATUS = 'SET_LOYALTY_STATUS';

export function clearLoginData() {
    return {
        type: CLEAR_LOGIN_DATA,
        payload: {}
    };
}

export function loginCanceled() {
    return {
        type: LOGIN_CANCELED
    };
}

export function loginSuccess(response) {
    return {
        type: LOGIN_SUCCESS,
        payload: {
            data: response
        }
    };
}

export function loginFinished(currentSession) {
    return {
        type: LOGIN_FINISHED,
        payload: {
            session: currentSession
        }
    };
}

export function signOutSuccess(response) {
    return {
        type: SIGNOUT_SUCCESS,
        payload: {
            data: response
        }
    };
}

/**
 * Login form data
 * @param {Object} formData Map of the form data
 * @param {Array} msgs List of error messages on the form (on client-side validation)
 * @param {Array} previousMsgs List of previous error messages on the form (on client-side validation).
 * @return {Object} Redux action
 */
export function loginData(formData, msgs, previousMsgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);
    const redraw = JSON.stringify(previousMsgs) !== JSON.stringify(convertedMsgs);

    return {
        type: LOGIN_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs,
            redraw: redraw
        }
    };
}

export function loginFailure(response) {
    const payload = buildErrorsFromResponse(response, "ERROR_LOGIN");
    return {
        type: LOGIN_FAILURE,
        error: true,
        payload: payload
    };
}

/**
 * Sign-up form data
 * @param {Object} formData Map of the form data
 * @param {Array} msgs List of error messages on the form (on client-side validation)
 * @param {Array} previousMsgs List of previous error messages on the form (on client-side validation).
 * @return {Object} Redux action
 */
export function signupData(formData, msgs, previousMsgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);
    const redraw = JSON.stringify(previousMsgs) !== JSON.stringify(convertedMsgs);

    return {
        type: SIGNUP_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs,
            redraw: redraw
        }
    };
}

/**
 * Sign up failure action
 *
 * @param {Object} response REST response object from an unsuccessful server call
 * @param {Array} msgs List of error messages on the form (on client-side validation)
 * @param {Array} previousMsgs List of previous error messages on the form (on client-side validation).
 * @return {Object} Redux action
 *
 * Submit response or msgs but not both.
 */
export function signupFailure(response, msgs, previousMsgs) {
    let payload = {};
    if (response) {
        response.request = {
            errorPrefix: "ERROR_ACCOUNT_CREATE"
        };
        payload = buildErrorsFromResponse(response);
    } else {
        payload = buildErrorsFromMsgs(msgs);
    }

    return {
        type: SIGNUP_FAILURE,
        error: true,
        payload: payload
    };
}

/**
 * Forgot password form data
 * @param {Object} formData Map of the form data
 * @param {Array}  msgs List of error messages on the form (on client-side validation)
 * @param {Array} previousMsgs List of previous error messages on the form (on client-side validation).
 * @return {Object} Redux action
 */
export function sendPasswordData(formData, msgs, previousMsgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);
    const redraw = JSON.stringify(previousMsgs) !== JSON.stringify(convertedMsgs);

    return {
        type: SEND_PASSWORD_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs,
            redraw: redraw
        }
    };
}

export function sendPasswordResetSuccess() {
    return {
        type: SEND_PASSWORD_RESET_SUCCESS
    };
}

export function sendForgotPasswordFailure(response) {
    response.request = {
        errorPrefix: "ERROR_FORGOT_PASSWORD"
    };
    const payload = buildErrorsFromResponse(response);
    return {
        type: SEND_PASSWORD_RESET_FAILURE,
        payload: payload,
        error: true
    };
}

export function requestLoyaltySubscription() {
    return {
        type: REQUEST_LOYALTY_SUBSCRIPTION
    };
}

export function receiveLoyaltySubscription(res) {
    return {
        type: RECEIVE_LOYALTY_SUBSCRIPTION,
        payload: res
    };
}

export function requestUserAddresses() {
    return {
        type: REQUEST_USER_ADDRESSES
    };
}

export function receiveUserAddresses() {
    return {
        type: RECEIVE_USER_ADDRESSES
    };
}

export function requestUserPreferences(preferenceType) {
    return {
        type: REQUEST_USER_PREFERENCES,
        payload: {
            preferenceType: preferenceType
        }
    };
}

export function receiveUserPreferences(res) {
    return {
        type: RECEIVE_USER_PREFERENCES,
        payload: res
    };
}

export function userLoginHandled(payload) {
    return {
        type: USER_LOGIN_HANDLED,
        payload
    };
}

export function loyaltyViewReady() {
    return {
        type: LOYALTY_VIEW_READY
    };
}

export function disableLoyaltyModal(disableModal) {
    return {
        type: DISABLE_LOYALTY_MODAL,
        payload: {
            disableModal: disableModal
        }
    };
}

export function sendEmailSignUpData(formData, msgs, previousMsgs, storeRoot = 'modal') {
    const convertedMsgs = buildErrorsFromMsgs(msgs);
    const redraw = JSON.stringify(previousMsgs) !== JSON.stringify(convertedMsgs);

    return {
        type: SEND_EMAIL_SIGNUP_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs,
            redraw: redraw,
            storeRoot: storeRoot
        }
    };
}

export function clearEmailSignUpData(storeRoot = 'modal') {
    return {
        type: CLEAR_EMAIL_SIGNUP_DATA,
        payload: {
            storeRoot: storeRoot
        }
    };
}

export function saveEmailSignUpData(formData) {
    return {
        type: SAVE_EMAIL_SIGNUP_DATA,
        payload: {
            formData: formData
        }
    };
}

export function emailSignupFailure(response, storeRoot) {
    const payload = buildErrorsFromResponse(response);
    return {
        type: EMAIL_SIGNUP_FAILURE,
        payload: {
            msgs: payload,
            storeRoot: storeRoot
        },
        error: true
    };
}

export function stickySignUpSuccess(response, storeRoot) {
    return {
        type: STICKY_SIGNUP_SUCCESS
    };
}

export function updateloyaltyUserName(username) {
    return {
        type: UPDATE_LOYALTY_USERNAME,
        payload: {
            username: username
        }
    };
}

export function setLoyaltyStatus(loyaltyState) {
    return {
        type: SET_LOYALTY_STATUS,
        payload: {
            loyalty: loyaltyState
        }
    };
}
